module.exports = __webpack_public_path__ + "static/Bucees_pin-d5986263f449a5a9c573ad2feb1b977a.png";